class MrDigitalSignageSlide extends HTMLElement {
	#currentIndex = 0;

	#sliderDuration = 10000;

	#pauseDuration = 500;

	#sliderTimelineTimeout: number = 0;

	connectedCallback() {
		requestAnimationFrame( () => {
			this.sliderTimelineAnimation();

			setTimeout( () => {
				this.goToNextItem();
			}, this.#sliderDuration );
		} );
	}

	sliderTimelineAnimation() {
		document.body.setAttribute( 'data-timeline-animation', '' );

		window.clearTimeout( this.#sliderTimelineTimeout );
		this.#sliderTimelineTimeout = window.setTimeout( () => {
			requestAnimationFrame( () => {
				document.body.removeAttribute( 'data-timeline-animation' );
			} );
		}, this.#sliderDuration );
	}

	resetTimeline() {
		window.clearTimeout( this.#sliderTimelineTimeout );
		document.body.removeAttribute( 'data-timeline-animation' );
	}

	private goToNextItem() {
		const items = this.querySelectorAll( '[data-slide-item]' );

		// first fade out previous item.
		this.updateStateForPreviousSelector( 'item', this.#currentIndex );

		// then go to next item.
		setTimeout( () => {
			const newIndex = indexPlusOne( this.#currentIndex, items.length );
			if ( newIndex === this.#currentIndex ) {
				location.reload();
			}

			this.#currentIndex = newIndex;
			this.updateStateForSelector( 'item', newIndex );

			setTimeout( () => {
				if ( newIndex < items.length - 1 ) {
					this.goToNextItem();
				} else {
					location.reload();
				}
			}, this.#sliderDuration );
		}, this.#pauseDuration );
	}

	private updateStateForPreviousSelector( selector: string, previousIndex: number ) {
		const items = this.querySelectorAll( `[data-slide-${selector}]` );
		const length = items.length;

		// Check if items not available.
		if ( 2 > length ) {
			return;
		}

		const previous = items[previousIndex];

		previous.removeAttribute( `data-slide-${selector}-current` );

		this.resetTimeline(); // reset timer animation.
	}

	private updateStateForSelector( selector: string, index: number ) {
		const items = this.querySelectorAll( `[data-slide-${selector}]` );
		const length = items.length;

		// Check if items not available.
		if ( 2 > length ) {
			return;
		}

		{
			const next = items[indexPlusOne( index, length )];
			if ( next ) {
				next.removeAttribute( 'loading' );
				next.setAttribute( `data-slide-${selector}-next`, '' );
			}
		}

		const current = items[index];
		current.setAttribute( `data-slide-${selector}-next`, '' );
		current.setAttribute( `data-slide-${selector}-current`, '' );

		this.sliderTimelineAnimation(); // start timer animation.

		current.querySelector( '[data-slide-header]' )?.setAttribute( 'data-slide-header-animation', '' );
		current.querySelector( '[data-slide-poster]' )?.setAttribute( 'data-slide-poster-animation', '' );
		current.querySelector( '[data-slide-footer]' )?.setAttribute( 'data-slide-footer-animation', '' );
	}

	disconnectedCallback() {
		// Reset States.
		this.#currentIndex = 0;
	}
}

customElements.define( 'mr-digital-signage-slide', MrDigitalSignageSlide );

function indexPlusOne( i: number, maxValue: number ): number {
	if ( 2 > maxValue ) {
		return 0;
	}

	let index = i;

	index++;

	if ( index >= maxValue ) {
		return 0;
	}

	return index;
}
